import React from 'react';
import { useSelector } from 'react-redux';

import Anontools from '@plone/volto/components/theme/Anontools/Anontools';
import LanguageSelector from '@plone/volto/components/theme/LanguageSelector/LanguageSelector';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

export const MobileToolsFooter = () => {
  const token = useSelector((state) => state.userSession.token);
  const siteAction = useSelector(
    (state) => state.content.data?.['@components']?.actions?.site_actions,
  );

  return (
    <ul className="mobile-tools">
      <li>
        <div className="mobile-tools-wrapper">
          {!token && <Anontools />}
          {siteAction &&
            siteAction.map((item) => (
              <UniversalLink key={item.url} href={item.url}>
                {item.title}
              </UniversalLink>
            ))}
        </div>
      </li>
    </ul>
  );
};
